import { render } from "./beforeAfterTwo.vue?vue&type=template&id=00dafbda"
import script from "./beforeAfterTwo.vue?vue&type=script&lang=js"
export * from "./beforeAfterTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__